import React, { useEffect, useState } from 'react';
import { useDispatch, useMappedState } from 'redux-react-hook';
import { Trans } from '@lingui/macro';
import { Link } from '@reach/router';
import { linkTo } from 'utils/links';

// Redux
import { loadPost } from 'store/modules/blog/actions';
import { getLoadedPost } from 'store/modules/blog/selectors';
import { getCurrentUser } from 'store/modules/auth/selectors';

// Components
import DateLabel from 'components/DateTime/Label';
import HeaderTitle from 'containers/HeaderTitle';
import Image from 'components/Image';
import CommentForm from 'containers/Comments/CommentForm';
import CommentList from 'containers/Comments/CommentList';
import NotFound from 'containers/Layout/NotFound';

import './styles.css';


const mapState = state => ({
  current: getCurrentUser(state),
  post: getLoadedPost(state),
});

export default function Post({ postId }) {
  const dispatch = useDispatch();
  const { current, post } = useMappedState(mapState);
  const [found, setFound] = useState(true);

  useEffect(() => {
    dispatch(loadPost(postId))
      .catch(() => setFound(false));
  }, [postId]);

  if (!found) {
    return <NotFound />;
  }

  return (
    <div className="h-full overflow-auto scrolling-touch px-4 md:pt-12 md:px-8">
      <HeaderTitle title={post.title} />
      <div className="container xl:w-1/2">
        <Image
          src={post.asset ? post.asset.url : ''}
          className="mb-2 w-full rounded bg-cover bg-center bg-no-repeat bg-list-active"
          style={{ maxHeight: '300px' }}
          background
        />
        <h2 className="mb-2 text-default font-sans font-thin text-2xl md:text-3xl xl:text-4xl">{post.title}</h2>
        <p className="mb-4 text-tertiary text-sm leading-normal capitalize italic xl:text-base">
          <Trans>Written by</Trans> <Link to={linkTo('/members/profiles/:slug', post.author)} className="text-secondary hover:underline">{post.author.name}</Link> &bull; <DateLabel date={post.time} />.
        </p>
        <div className="Post__content text-default text-base leading-normal xl:text-lg" dangerouslySetInnerHTML={{ __html: post.html }} />
        <CommentList model="post" id={post.id} />
        <CommentForm model="post" id={post.id} isLoggedIn={!!current.id} />
      </div>
    </div>
  );
}
